module.exports = {
	"_args": [
		[
			{
				"raw": "matrix-react-sdk@0.9.7",
				"scope": null,
				"escapedName": "matrix-react-sdk",
				"name": "matrix-react-sdk",
				"rawSpec": "0.9.7",
				"spec": "0.9.7",
				"type": "version"
			},
			"/private/var/folders/w1/zlp00m5x3fnc1y7qdzlwlk3m0000gn/T/tmp.bwCpKQk8"
		]
	],
	"_from": "matrix-react-sdk@0.9.7",
	"_id": "matrix-react-sdk@0.9.7",
	"_inCache": true,
	"_location": "/matrix-react-sdk",
	"_nodeVersion": "7.4.0",
	"_npmOperationalInternal": {
		"host": "s3://npm-registry-packages",
		"tmp": "tmp/matrix-react-sdk-0.9.7.tgz_1498129073490_0.13296361221000552"
	},
	"_npmUser": {
		"name": "matrixdotorg",
		"email": "matrix@matrix.org"
	},
	"_npmVersion": "4.0.5",
	"_phantomChildren": {},
	"_requested": {
		"raw": "matrix-react-sdk@0.9.7",
		"scope": null,
		"escapedName": "matrix-react-sdk",
		"name": "matrix-react-sdk",
		"rawSpec": "0.9.7",
		"spec": "0.9.7",
		"type": "version"
	},
	"_requiredBy": [
		"/"
	],
	"_resolved": "https://registry.npmjs.org/matrix-react-sdk/-/matrix-react-sdk-0.9.7.tgz",
	"_shasum": "779ccc6c504e349802894a4a8ba9e0d21247ca38",
	"_shrinkwrap": null,
	"_spec": "matrix-react-sdk@0.9.7",
	"_where": "/private/var/folders/w1/zlp00m5x3fnc1y7qdzlwlk3m0000gn/T/tmp.bwCpKQk8",
	"author": {
		"name": "matrix.org"
	},
	"bin": {
		"reskindex": "scripts/reskindex.js"
	},
	"bugs": {
		"url": "https://github.com/matrix-org/matrix-react-sdk/issues"
	},
	"dependencies": {
		"babel-runtime": "^6.11.6",
		"blueimp-canvas-to-blob": "^3.5.0",
		"browser-encrypt-attachment": "^0.3.0",
		"browser-request": "^0.3.3",
		"classnames": "^2.1.2",
		"commonmark": "^0.27.0",
		"counterpart": "^0.18.0",
		"draft-js": "^0.8.1",
		"draft-js-export-html": "^0.5.0",
		"draft-js-export-markdown": "^0.2.0",
		"emojione": "2.2.3",
		"file-saver": "^1.3.3",
		"filesize": "3.5.6",
		"flux": "2.1.1",
		"fuse.js": "^2.2.0",
		"glob": "^5.0.14",
		"highlight.js": "^8.9.1",
		"isomorphic-fetch": "^2.2.1",
		"linkifyjs": "^2.1.3",
		"lodash": "^4.13.1",
		"matrix-js-sdk": "0.7.13",
		"optimist": "^0.6.1",
		"prop-types": "^15.5.8",
		"q": "^1.4.1",
		"react": "^15.4.0",
		"react-addons-css-transition-group": "15.3.2",
		"react-dom": "^15.4.0",
		"react-gemini-scrollbar": "github:matrix-org/react-gemini-scrollbar#5e97aef",
		"sanitize-html": "^1.11.1",
		"text-encoding-utf-8": "^1.0.1",
		"velocity-vector": "github:vector-im/velocity#059e3b2",
		"whatwg-fetch": "^1.0.0"
	},
	"description": "SDK for matrix.org using React",
	"devDependencies": {
		"babel-cli": "^6.5.2",
		"babel-core": "^6.14.0",
		"babel-eslint": "^6.1.2",
		"babel-loader": "^6.2.5",
		"babel-plugin-add-module-exports": "^0.2.1",
		"babel-plugin-transform-async-to-generator": "^6.16.0",
		"babel-plugin-transform-class-properties": "^6.16.0",
		"babel-plugin-transform-object-rest-spread": "^6.16.0",
		"babel-plugin-transform-runtime": "^6.15.0",
		"babel-polyfill": "^6.5.0",
		"babel-preset-es2015": "^6.14.0",
		"babel-preset-es2016": "^6.11.3",
		"babel-preset-es2017": "^6.14.0",
		"babel-preset-react": "^6.11.1",
		"chokidar": "^1.6.1",
		"eslint": "^3.13.1",
		"eslint-config-google": "^0.7.1",
		"eslint-plugin-babel": "^4.0.1",
		"eslint-plugin-flowtype": "^2.30.0",
		"eslint-plugin-react": "^6.9.0",
		"expect": "^1.16.0",
		"json-loader": "^0.5.3",
		"karma": "^0.13.22",
		"karma-chrome-launcher": "^0.2.3",
		"karma-cli": "^0.1.2",
		"karma-junit-reporter": "^0.4.1",
		"karma-mocha": "^0.2.2",
		"karma-phantomjs-launcher": "^1.0.0",
		"karma-sourcemap-loader": "^0.3.7",
		"karma-webpack": "^1.7.0",
		"mocha": "^2.4.5",
		"parallelshell": "^1.2.0",
		"phantomjs-prebuilt": "^2.1.7",
		"react-addons-test-utils": "^15.4.0",
		"require-json": "0.0.1",
		"rimraf": "^2.4.3",
		"sinon": "^1.17.3",
		"source-map-loader": "^0.1.5",
		"webpack": "^1.12.14"
	},
	"directories": {},
	"dist": {
		"shasum": "779ccc6c504e349802894a4a8ba9e0d21247ca38",
		"tarball": "https://registry.npmjs.org/matrix-react-sdk/-/matrix-react-sdk-0.9.7.tgz"
	},
	"files": [
		".eslintrc.js",
		"CHANGELOG.md",
		"CONTRIBUTING.rst",
		"LICENSE",
		"README.md",
		"code_style.md",
		"git-revision.txt",
		"header",
		"jenkins.sh",
		"karma.conf.js",
		"lib",
		"package.json",
		"release.sh",
		"scripts",
		"src",
		"test"
	],
	"gitHead": "f7aad3c422f83459cf4657ce260d4bf050d30c4b",
	"homepage": "https://github.com/matrix-org/matrix-react-sdk#readme",
	"license": "Apache-2.0",
	"main": "lib/index.js",
	"maintainers": [
		{
			"name": "matrixdotorg",
			"email": "matrix@matrix.org"
		}
	],
	"name": "matrix-react-sdk",
	"optionalDependencies": {},
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/matrix-org/matrix-react-sdk.git"
	},
	"scripts": {
		"build": "npm run reskindex && babel src -d lib --source-maps",
		"build:watch": "babel src -w -d lib --source-maps",
		"clean": "rimraf lib",
		"lint": "eslint src/",
		"lintall": "eslint src/ test/",
		"prepublish": "npm run build && git rev-parse HEAD > git-revision.txt",
		"reskindex": "node scripts/reskindex.js -h header",
		"reskindex:watch": "node scripts/reskindex.js -h header -w",
		"start": "parallelshell \"npm run build:watch\" \"npm run reskindex:watch\"",
		"test": "karma start $KARMAFLAGS --browsers PhantomJS",
		"test-multi": "karma start $KARMAFLAGS --single-run=false"
	},
	"version": "0.9.7"
};


//////////////////
// WEBPACK FOOTER
// ./~/matrix-react-sdk/package.json
// module id = 639
// module chunks = 1